export default {
  name: 'StarPopover',
  props: ['totalScore', 'breakdown'],
  data() {
    return {
      percentage: JSON.parse(this.breakdown),
      isActive: false,
      isBarActive: false,
    }
  },
  created() {
    document.addEventListener('click', this.documentClick)
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick)
  },
  methods: {
    toggle() {
      this.isActive ? this.close() : (this.isActive = true)
    },
    close() {
      this.isActive = false
      this.isBarActive = false
    },
    documentClick(e) {
      const el = this.$refs.starWrapper
      const target = e.target
      if (el !== target && !el.contains(target)) {
        this.close()
      }
    },
    getStarStyle() {
      return `width: calc(${this.totalScore} / 5 * 100%);`
    },
    getBarStyle(i) {
      if (this.isBarActive) {
        return `width: ${this.percentage[i]};`
      }
    },
  },
}
